import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  fieldsLabels: string[]
}

const TableHeaderComponent = ({ fieldsLabels }: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        {fieldsLabels.map((label, key) => (
          <Table.HeadCell key={key} width={360} colSpan={1}>
            {label}
          </Table.HeadCell>
        ))}
        <Table.HeadCell width={64} />
      </Table.Row>
    </Table.Head>
  )
}

export default observer(TableHeaderComponent)
